import { render, staticRenderFns } from "./manCard.vue?vue&type=template&id=08f78652&scoped=true&"
import script from "./manCard.vue?vue&type=script&lang=ts&"
export * from "./manCard.vue?vue&type=script&lang=ts&"
import style0 from "./manCard.vue?vue&type=style&index=0&id=08f78652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f78652",
  null
  
)

export default component.exports